(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
    typeof define === 'function' && define.amd ? define(['exports'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global['one-user'] = {}));
}(this, (function (exports) { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */

    /** @deprecated */
    function __spreadArrays() {
        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
        for (var r = Array(s), k = 0, i = 0; i < il; i++)
            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
                r[k] = a[j];
        return r;
    }

    var Unit;
    (function (Unit) {
        Unit["BIN"] = "BIN";
        Unit["CAM"] = "CAM";
        Unit["CEBR"] = "CEBR";
        Unit["CEDE"] = "CEDE";
        Unit["CEES"] = "CEES";
        Unit["CEIT"] = "CEIT";
        Unit["CEUK"] = "CEUK";
        Unit["FRGTS"] = "FRGTS";
        Unit["FROMM"] = "FROMM";
        Unit["GALA"] = "GALA";
        Unit["GEO"] = "GEO";
        Unit["NEON"] = "NEON";
        Unit["NGE"] = "NGE";
        Unit["PECO"] = "PECO";
        Unit["PFEM"] = "PFEM";
        Unit["PTVS"] = "PTVS";
        Unit["TRV"] = "TRV";
        Unit["VOICI"] = "VOICI";
        Unit["TESTUNIT"] = "TEST-UNIT";
    })(Unit || (Unit = {}));
    function isUnit(maybeUnit) {
        return Object.entries(Unit).some(function (_a) {
            var unit = _a[1];
            return unit === maybeUnit;
        });
    }

    var _a, _b;
    var BrandKey;
    (function (BrandKey) {
        BrandKey["ATN"] = "ATN";
        BrandKey["BEA"] = "BEA";
        BrandKey["BIN"] = "BIN";
        BrandKey["BRGTS"] = "BRGTS";
        BrandKey["BROMM"] = "BROMM";
        BrandKey["CAC"] = "CAC";
        BrandKey["CAM"] = "CAM";
        BrandKey["CAP"] = "CAP";
        BrandKey["CTP"] = "CTP";
        BrandKey["DEGTS"] = "DEGTS";
        BrandKey["DEOMM"] = "DEOMM";
        BrandKey["ESGTS"] = "ESGTS";
        BrandKey["ESOMM"] = "ESOMM";
        BrandKey["FAC"] = "FAC";
        BrandKey["FLW"] = "FLW";
        BrandKey["FRGTS"] = "FRGTS";
        BrandKey["FRGSD"] = "FRGSD";
        BrandKey["FRGSG"] = "FRGSG";
        BrandKey["FRGSL"] = "FRGSL";
        BrandKey["FRGSS"] = "FRGSS";
        BrandKey["FRGSV"] = "FRGSV";
        BrandKey["FROMM"] = "FROMM";
        BrandKey["GAL"] = "GAL";
        BrandKey["GEO"] = "GEO";
        BrandKey["HBR"] = "HBR";
        BrandKey["ITGTS"] = "ITGTS";
        BrandKey["ITOMM"] = "ITOMM";
        BrandKey["MAN"] = "MAN";
        BrandKey["NEO"] = "NEO";
        BrandKey["NGE"] = "NGE";
        BrandKey["OMM"] = "OMM";
        BrandKey["PRA"] = "PRA";
        BrandKey["SRG"] = "SRG";
        BrandKey["TEL"] = "TEL";
        BrandKey["TGC"] = "TGC";
        BrandKey["TLA"] = "TLA";
        BrandKey["TLS"] = "TLS";
        BrandKey["TRV"] = "TRV";
        BrandKey["TVJ"] = "TVJ";
        BrandKey["UKGTS"] = "UKGTS";
        BrandKey["UKOMM"] = "UKOMM";
        BrandKey["VOI"] = "VOI";
        BrandKey["TESTBRAND"] = "TEST-BRAND";
        // legacy articles access for ADMIN only
        BrandKey["CTR"] = "CTR";
        BrandKey["VDF"] = "VDF";
    })(BrandKey || (BrandKey = {}));
    var brandKeysByUnit = (_a = {},
        _a[Unit.BIN] = [BrandKey.BIN],
        _a[Unit.CAM] = [BrandKey.CAM],
        _a[Unit.CEBR] = [BrandKey.BRGTS, BrandKey.BROMM],
        _a[Unit.CEDE] = [BrandKey.DEGTS, BrandKey.DEOMM],
        _a[Unit.CEES] = [BrandKey.ESGTS, BrandKey.ESOMM],
        _a[Unit.CEIT] = [BrandKey.ITGTS, BrandKey.ITOMM],
        _a[Unit.CEUK] = [BrandKey.UKGTS, BrandKey.UKOMM],
        _a[Unit.FRGTS] = [
            BrandKey.FRGTS,
            BrandKey.FRGSD,
            BrandKey.FRGSG,
            BrandKey.FRGSL,
            BrandKey.FRGSS,
            BrandKey.FRGSV,
        ],
        _a[Unit.FROMM] = [BrandKey.FROMM],
        _a[Unit.GALA] = [BrandKey.GAL],
        _a[Unit.GEO] = [BrandKey.GEO],
        _a[Unit.NEON] = [BrandKey.NEO],
        _a[Unit.NGE] = [BrandKey.NGE],
        _a[Unit.PECO] = [BrandKey.ATN, BrandKey.CAP, BrandKey.HBR, BrandKey.MAN],
        _a[Unit.PFEM] = [
            BrandKey.BEA,
            BrandKey.CAC,
            BrandKey.FAC,
            BrandKey.FLW,
            BrandKey.OMM,
            BrandKey.PRA,
            BrandKey.SRG,
        ],
        _a[Unit.PTVS] = [
            BrandKey.CTP,
            BrandKey.CTR,
            BrandKey.TEL,
            BrandKey.TGC,
            BrandKey.TLA,
            BrandKey.TLS,
            BrandKey.TVJ,
        ],
        _a[Unit.TRV] = [BrandKey.TRV],
        _a[Unit.VOICI] = [BrandKey.VOI],
        _a[Unit.TESTUNIT] = [BrandKey.CTR, BrandKey.VDF, BrandKey.TESTBRAND],
        _a);
    (_b = {},
        _b[BrandKey.ATN] = 'Athenee',
        _b[BrandKey.BEA] = 'Beauté Addict',
        _b[BrandKey.BIN] = 'Business insider',
        _b[BrandKey.BRGTS] = 'BR Gentside',
        _b[BrandKey.BROMM] = 'BR Ohmymag',
        _b[BrandKey.CAC] = 'Cuisine Actuelle',
        _b[BrandKey.CAM] = "Ça m'intéresse",
        _b[BrandKey.CAP] = 'Capital',
        _b[BrandKey.CTP] = '100% programme TV',
        _b[BrandKey.CTR] = 'Ciné Télé Revue',
        _b[BrandKey.DEGTS] = 'DE Gentside',
        _b[BrandKey.DEOMM] = 'DE Ohmymag',
        _b[BrandKey.ESGTS] = 'ES Gentside',
        _b[BrandKey.ESOMM] = 'ES Ohmymag',
        _b[BrandKey.FAC] = 'Femme Actuelle',
        _b[BrandKey.FLW] = 'Flow',
        _b[BrandKey.FRGTS] = 'FR Gentside',
        _b[BrandKey.FRGSD] = 'FR Gentside Découverte',
        _b[BrandKey.FRGSG] = 'FR Gentside Gaming',
        _b[BrandKey.FRGSL] = 'FR Gentside Lifestyle',
        _b[BrandKey.FRGSS] = 'FR Gentside Sport',
        _b[BrandKey.FRGSV] = 'FR Gentside Voyage',
        _b[BrandKey.FROMM] = 'FR Ohmymag',
        _b[BrandKey.GAL] = 'Gala',
        _b[BrandKey.GEO] = 'GEO',
        _b[BrandKey.HBR] = 'Harvard Business Review',
        _b[BrandKey.ITGTS] = 'IT Gentside',
        _b[BrandKey.ITOMM] = 'IT Ohmymag',
        _b[BrandKey.MAN] = 'Management',
        _b[BrandKey.NEO] = 'Néon',
        _b[BrandKey.NGE] = 'National Geographic',
        _b[BrandKey.OMM] = 'Ohmymag',
        _b[BrandKey.PRA] = 'Prima',
        _b[BrandKey.SRG] = 'Femme Actuelle Senior',
        _b[BrandKey.TEL] = 'Télé-loisirs',
        _b[BrandKey.TGC] = 'TV Grandes chaines',
        _b[BrandKey.TLA] = 'Télé-loisirs Afrique',
        _b[BrandKey.TLS] = 'Télé 2 semaines',
        _b[BrandKey.TRV] = 'Transverse',
        _b[BrandKey.TVJ] = 'Télé + de jeux + lisible',
        _b[BrandKey.UKGTS] = 'UK Gentside',
        _b[BrandKey.UKOMM] = 'UK Ohmymag',
        _b[BrandKey.VDF] = 'Vie de Famille',
        _b[BrandKey.VOI] = 'Voici',
        _b[BrandKey.TESTBRAND] = 'Test brand',
        _b);
    function getBrandKeysForUnits(units) {
        return units.reduce(function (brandKeys, unit) { return __spreadArrays(brandKeys, brandKeysByUnit[unit]); }, []);
    }

    function getEnumKeys(enumerable) {
        var keys = [];
        for (var _i = 0, _a = Object.keys(enumerable); _i < _a.length; _i++) {
            var key = _a[_i];
            if (Number.isNaN(Number.parseInt(key))) {
                keys.push(key);
            }
        }
        return keys;
    }
    function getEnumValues(enumerable) {
        return getEnumKeys(enumerable).map(function (key) { return enumerable[key]; });
    }

    (function (Role) {
        Role["Admin"] = "ADMIN";
        Role["Icono"] = "ICONO";
        Role["Maquettiste"] = "MAQUETTISTE";
        Role["Nl"] = "NL";
        Role["NlAdmin"] = "ADMIN_NL";
        Role["PhotoAdminCuisine"] = "ADMIN_PHOTO_CUISINE";
        Role["Pigiste"] = "PIGISTE";
        Role["ReadOnly"] = "READ_ONLY";
        Role["Redacteur"] = "REDACTEUR";
        Role["SR"] = "SR";
        Role["Superadmin"] = "SUPERADMIN";
        Role["Validateur"] = "VALIDATEUR";
        Role["Web"] = "WEB";
        Role["WebAdmin"] = "ADMIN_WEB";
    })(exports.Role || (exports.Role = {}));
    function isRole(maybeRole) {
        return Object.entries(exports.Role).some(function (_a) {
            var role = _a[1];
            return role === maybeRole;
        });
    }

    function isRoleUnit(maybeRoleUnit) {
        return isUnit(maybeRoleUnit) || maybeRoleUnit === 'ALL';
    }

    var InvalidUserError = /** @class */ (function (_super) {
        __extends(InvalidUserError, _super);
        function InvalidUserError() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return InvalidUserError;
    }(Error));
    var User = /** @class */ (function () {
        function User(user) {
            if (!user.id || !user.email || !Array.isArray(user.roles)) {
                throw new InvalidUserError();
            }
            this.id = user.id;
            this.name = user.name;
            this.email = user.email;
            this.createdAt = user.createdAt || '';
            this.googleId = user.googleId || null;
            this.avatarUrl = user.avatarUrl || null;
            this.roles = user.roles.filter(function (roleWithUnit) {
                var _a = roleWithUnit.split('-'), role = _a[0], brandKey = _a[1];
                return isRole(role) && (brandKey === 'ALL' || isUnit(brandKey));
            });
        }
        Object.defineProperty(User.prototype, "roleMap", {
            get: function () {
                return this.roles.reduce(function (roleMap, role) {
                    var _a;
                    var explodedRole = role.split('-');
                    if (explodedRole.length === 2) {
                        var maybeRole = explodedRole[0], maybeUnit = explodedRole[1];
                        if (isRole(maybeRole) && isRoleUnit(maybeUnit)) {
                            if (!(maybeRole in roleMap)) {
                                roleMap[maybeRole] = [];
                            }
                            if (!roleMap[maybeRole].includes(maybeUnit)) {
                                (_a = roleMap[maybeRole]) === null || _a === void 0 ? void 0 : _a.push(maybeUnit);
                            }
                        }
                    }
                    return roleMap;
                }, {});
            },
            enumerable: false,
            configurable: true
        });
        User.prototype.hasRoleOnUnit = function (role, unit) {
            if (unit === void 0) { unit = 'ALL'; }
            return (this.hasRole(role) &&
                (this.roleMap[role].includes(unit) ||
                    (unit !== 'ALL' && this.roleMap[role].includes('ALL'))));
        };
        User.prototype.hasRole = function (role) {
            return isRole(role) && !!this.roleMap[role];
        };
        User.prototype.hasRolesOnUnit = function (roles, unit) {
            var _this = this;
            return roles.some(function (role) { return _this.hasRoleOnUnit(role, unit); });
        };
        User.prototype.hasRoleOnUnits = function (role, units) {
            var _this = this;
            return units.some(function (unit) { return _this.hasRoleOnUnit(role, unit); });
        };
        User.prototype.hasRolesOnUnits = function (roles, units) {
            var _this = this;
            return roles.some(function (role) { return units.some(function (unit) { return _this.hasRoleOnUnit(role, unit); }); });
        };
        User.prototype.isSuperAdmin = function () {
            return this.hasRoleOnUnit(exports.Role.Superadmin);
        };
        User.prototype.assertIsSuperAdmin = function () {
            if (!this.isSuperAdmin()) {
                throw new Error("User should be a superadmin");
            }
        };
        User.prototype.isAdmin = function (unit) {
            return this.hasRoleOnUnit(exports.Role.Admin, unit);
        };
        User.prototype.assertIsAdmin = function (unit) {
            if (!this.isAdmin(unit)) {
                throw new Error("User should be an admin");
            }
        };
        User.prototype.getUnitSet = function (excludedRoles) {
            if (excludedRoles === void 0) { excludedRoles = []; }
            var units = Object.entries(this.roleMap).reduce(function (currentUnits, _a) {
                var role = _a[0], units = _a[1];
                if (!excludedRoles.includes(role) && units) {
                    currentUnits.push.apply(currentUnits, units.filter(function (unit) { return unit !== 'ALL'; }));
                }
                return currentUnits;
            }, []);
            return new Set(units);
        };
        /**
         * "ALL" is a special unit
         */
        User.prototype.getUnits = function (excludedRoles) {
            if (excludedRoles === void 0) { excludedRoles = []; }
            //We filter "ALL" from RoleUnit, so we can cast the return to Unit[]
            return Array.from(this.getUnitSet(excludedRoles)).filter(function (unit) { return !['ALL'].includes(unit); });
        };
        User.prototype.getUnitsForRoles = function (roles) {
            var units = new Set();
            // using for so we can break early in case of a role with 'ALL'
            for (var i = 0; i < roles.length; i++) {
                if (this.hasRole(roles[i])) {
                    var rolesUnits = this.roleMap[roles[i]];
                    if (rolesUnits.includes('ALL')) {
                        return getEnumValues(Unit);
                    }
                    for (var _i = 0, _a = rolesUnits; _i < _a.length; _i++) {
                        var unit = _a[_i];
                        units.add(unit);
                    }
                }
            }
            return Array.from(units);
        };
        User.prototype.getUserBrandKeysForRoles = function (roles) {
            return getBrandKeysForUnits(this.getUnitsForRoles(roles));
        };
        //Todo:move this to topic api
        User.prototype.isAllowedOnRawArticle = function (rawArticle, roles, allowOwner) {
            if (this.isSuperAdmin() || this.isAdmin() || this.hasRolesOnUnit(roles)) {
                return true;
            }
            var unit = (rawArticle.assignment && rawArticle.assignment.subject.unit.title) || null;
            var editorId = (rawArticle.lastVersion && rawArticle.lastVersion.editorId) || null;
            return ((unit && (this.isAdmin(unit) || this.hasRolesOnUnit(roles, unit))) ||
                (allowOwner && editorId && this.id === editorId));
        };
        return User;
    }());

    exports.InvalidUserError = InvalidUserError;
    exports.default = User;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
